import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { Avatar } from "primereact/avatar";

const AppTopbar = (props: any) => {
  const navigate = useNavigate();

  // Safely parse user data
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;

  // parse rawUserData
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const userName = userData?.name;

  // logout function
  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <div className="layout-topbar">
        <div className="flex gap-2 md:gap-3 lg:gap-0 layout-topbar-left align-items-center ">
          <div className="topbar-start">
            <button
              className="ml-0 topbar-menu-button p-link"
              onClick={props.onMenuButtonClick}
            >
              <i className="pi pi-bars"></i>
            </button>
          </div>
          <img src="/assets/images/logo-text-white-tm.png" className="top-logo" alt="" />
        </div>

        {/* <div className="layout-topbar-left"> */}
        {/* <img src="/assets/images/logo-text-white-tm.png" alt="" width={110} /> */}
        {/* <h3 className="mb-0 product-name">AgriOwn</h3> */}
        {/* </div> */}

        <div className="flex layout-topbar-right align-items-center">
          <ul className="layout-topbar-right-items">
            <li
              id="profile"
              className={classNames("profile-item", {
                "active-topmenuitem": props.topbarMenuActive,
              })}
            >
              <button className="p-link" onClick={props.onTopbarItemClick}>
                {/* <img
                  src="/assets/images/avatar.png"
                  style={{ borderRadius: "50%" }}
                  alt="profile"
                /> */}

                {!window.cn(userName) ? (
                  <>
                    <Avatar
                      label={userName.charAt(0).toUpperCase()}
                      style={{ backgroundColor: "#438440", color: "#ffffff" }}
                      shape="circle"
                    />
                    <span className="ml-2 text-white profile-name">
                      {userName}
                    </span>
                  </>
                ) : (
                  <>
                    <Avatar
                      icon="pi pi-user"
                      style={{ backgroundColor: "#2196F3", color: "#ffffff" }}
                      shape="circle"
                    />
                    <span className="ml-2 text-white profile-name">
                      {userName}
                    </span>
                  </>
                )}
              </button>

              <ul className="fadeInDown">
                <li role="menuitem">
                  <button
                    className="w-full p-link"
                    onClick={() => navigate("/change-password")}
                  >
                    <i className="pi pi-fw pi-lock"></i>
                    <span>Change Password</span>
                  </button>
                </li>
                <li role="menuitem">
                  <button className="w-full p-link" onClick={logout}>
                    <i className="pi pi-fw pi-sign-out"></i>
                    <span>Logout</span>
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default AppTopbar;
